export default "__VITE_ASSET__$HqmlPCl__"